import React, {Component} from 'react';
import {translate} from 'react-i18next';
import FormBagsGroup from './components/FormBagsGroup'
import RaisedButton from 'material-ui/RaisedButton';

class BagsGroup extends Component{
	constructor(props){
		super(props);
	}

	render(){
		const {t} = this.props;
		return (
			<div className="col-xs-12" style={{paddingTop:"10px"}}>
				<div className="col-xs-12">
					<h5 className="title_page" >
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.process.MAIN')} ->
						{t('sidebar.nav.process.bags_group.MAIN')}
					</h5>
				</div>

				<form noValidate>
					<FormBagsGroup {...this.props} onRef={ref => (this.form = ref)} />
				</form>

				<div className="col-xs-12" style={{textAlign:'center'}}>
		        	<div>
		        		<RaisedButton className="action-btn" label={t('content.generics.buttons.save')} primary={true}  style={{margin:12}}/>
		        		<RaisedButton className="action-btn" label={t('content.generics.buttons.return')} primary={true} style={{margin:12}}/>
		        	</div>
		        </div>
			</div>
		)
	}
}

export default translate('translations')(BagsGroup);